<template>
  <v-container fluid>
    <ChannelSelect :current-module="this.$i18n.locale === 'en'? 'Events' : 'Eventos'"/>
    <p v-if="this.$store.state.clubEvents.length === 0" class="text-center" style="margin-top: 30%">
      <v-btn v-if="this.$store.state.clubMember.rol !== 'MEMBER'" class="button-add mb-5 mt-n5" @click="overlayAddEvent = true">
        {{ $t('btnAddFirst') }} <v-icon class="icon ml-2" color="white" small>fa-plus</v-icon></v-btn><br>
      {{ $t('noEvents') }}
    </p>

    <div v-else>
      <h1 class="text-start mb-5" v-if="startDateToFilter !== null">
        <v-icon class="arrow mt-n1" @click="prevMonth" small>fa-chevron-left</v-icon>
        {{ monthNames[startDateToFilter.getMonth()] }} {{ startDateToFilter.getFullYear() }}
        <v-icon class="arrow mt-n1" @click="nextMonth" small>fa-chevron-right</v-icon>
        <v-btn v-if="this.$store.state.clubMember.rol !== 'MEMBER'" class="button-add" @click="overlayAddEvent = true">
          {{ $t('btnAdd') }}
        </v-btn>
      </h1>
      <v-calendar ref="calendarCommunity" :events="events" :now="today" :value="today" v-model="focus"
                  :event-color="`#${this.$store.state.clubMember.club.primaryColor}`"
                  :color="`${this.$store.state.clubMember.club.primaryColor}`"
                  type="month" style="min-height: 70vh" @change="calendarChanged" @click:event="showEvent"/>
      <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
        <v-card min-width="350px" max-width="350px" flat>
          <v-toolbar :color="`#${this.$store.state.clubMember.club.primaryColor}`" elevation="0" dark>
            <h2 style="color: #FFFFFF">{{ selectedEvent.name }} <br><span>{{ $t('at') }} {{ selectedEvent.start }}</span></h2>
            <v-spacer></v-spacer>
            <v-icon class="icon" color="white" @click="selectedOpen = false">fa-times</v-icon>
          </v-toolbar>
          <v-card-text>
            <p class="mb-0" v-if="selectedEvent.details !== undefined"
               v-html="linkify(selectedEvent.details.description)"/>
          </v-card-text>
          <v-card-actions
              v-if="selectedEvent.details !== undefined && selectedEvent.details.clubMember.id === this.$store.state.clubMember.id">
            <v-chip @click="deleteEvent(selectedEvent.details)" class="ml-2 mb-2" small>
              <p style="font-size: 13px;" class="mb-0">{{ $t('btnDelete') }}
                <v-icon class="ml-1" x-small>fa-trash</v-icon>
              </p>
            </v-chip>
          </v-card-actions>
        </v-card>
      </v-menu>
    </div>

    <!-- Overlay show event !-->
    <v-overlay v-model="overlayShowDay">

    </v-overlay>
    <!-- Overlay for add event !-->
    <v-overlay :value="overlayAddEvent">
      <AddEvent @closeWindow="overlayAddEvent = false"/>
    </v-overlay>
    <!-- Overlay for delete event !-->
    <v-overlay :value="overlayDeleteEvent">
      <DeleteEvent :event="currentEvent" @closeWindow="overlayDeleteEvent = false"/>
    </v-overlay>
  </v-container>
</template>

<script>
import Repository from '../../../repositories/club';
import { mapMutations } from 'vuex';
import AddEvent from "@/views/Community/components/AddEvent";
import DeleteEvent from "@/views/Community/components/DeleteEvent";
import ChannelSelect from "@/views/Community/components/ChannelSelect";
export default {
  name: "ClubEvents",
  components: {ChannelSelect, DeleteEvent, AddEvent},
  data() {
    return {
      overlayShowDay: false,
      overlayAddEvent: false,
      overlayDeleteEvent: false,
      currentEvent: null,
      today: '',
      focus: '',
      startDateToFilter: null,
      endDateToFilter: null,
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      monthTrades: [],
      monthNames: [
        this.$t('months.jan'),
        this.$t('months.feb'),
        this.$t('months.mar'),
        this.$t('months.apr'),
        this.$t('months.may'),
        this.$t('months.jun'),
        this.$t('months.jul'),
        this.$t('months.aug'),
        this.$t('months.sep'),
        this.$t('months.oct'),
        this.$t('months.nov'),
        this.$t('months.dec')
      ],
      events: [],
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    '$store.state.clubEvents': function () {
      this.processEvents();
    },
    '$store.state.currentClubChannel': function () {
      this.refreshEvents();
    },
  },
  methods: {
    ...mapMutations(['setClubEvents']),
    refreshEvents() {
      Repository.getAllClubEventsByChannel(this.$store.state.clubMember.club.id, this.$store.state.currentClubChannel.id).then((response) => {
        if(response.status < 400)
          this.setClubEvents(response.data);
      });
    },
    ...mapMutations(['setClubEvents']),
    init() {
      this.today = this.getToday();
      this.$refs.calendarCommunity.checkChange();
      this.refreshEvents();
    },
    getToday() {
      this.focus = '';
      let today = new Date();
      this.startDateToFilter = new Date(today.getFullYear(), today.getMonth());
      this.endDateToFilter = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      return `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()} ${today.getHours()}:${today.getMinutes()}`;
    },
    async calendarChanged({start, end}) {
      await this.refreshDates(start, end);
    },
    async refreshDates(start, end) {
      this.$refs.calendarCommunity.checkChange();
      this.startDateToFilter = new Date(`${start.date}T00:00:00`);
      this.endDateToFilter = new Date(`${end.date}T23:59:59`);
    },
    prevMonth() {
      this.$refs.calendarCommunity.prev();
    },
    nextMonth() {
      this.$refs.calendarCommunity.next();
    },
    processEvents() {
      this.events = [];
      this.$store.state.clubEvents.forEach((event) => {
        this.events.push({
          name: event.name,
          start: this.formatDate(event.startDate),
          end: this.formatDate(event.endDate),
          details: event,
        });
      });
    },
    formatDate(stringDate) {
      let date = new Date(stringDate);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2,0)}-${String(date.getDate()).padStart(2,0)} ${String(date.getHours()).padStart(2,0)}:${String(date.getMinutes()).padStart(2, 0)}`;
    },
    showEvent ({ nativeEvent, event }) {
      // eslint-disable-next-line no-console
      console.log('Hereee');
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => {
          this.selectedOpen = true;
        }, 10);
      }

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else
        open();

      nativeEvent.stopPropagation();
    },
    deleteEvent(event) {
      this.currentEvent = event;
      this.selectedOpen = false;
      this.overlayDeleteEvent = true;
    },
    showDay() {
      this.overlayShowDay = true;
    },
    linkify(inputText) {
      let replacedText, replacePattern1, replacePattern2;

      //URLs starting with http://, https://, or ftp://
      // eslint-disable-next-line no-useless-escape
      replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
      replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

      //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
      // eslint-disable-next-line no-useless-escape
      replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
      replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
      return replacedText;
    },
  }
}
</script>

<i18n>
{
  "en": {
    "btnAdd": "Create Event",
    "btnAddFirst": "Create First Event",
    "btnDelete": "Delete",
    "at": "At",
    "months": {
      "jan" : "January",
      "feb" : "February",
      "mar" : "March",
      "apr" : "April",
      "may" : "May",
      "jun" : "June",
      "jul" : "July",
      "aug" : "August",
      "sep" : "September",
      "oct" : "October",
      "nov" : "November",
      "dec" : "December"
    },
    "noEvents": "There's no events yet in this channel :("
  },
  "es": {
    "btnAdd": "Crear Evento",
    "btnAddFirst": "Crear Primer Evento",
    "btnDelete": "Eliminar",
    "at": "El",
    "months": {
      "jan" : "Enero",
      "feb" : "Febrero",
      "mar" : "Marzo",
      "apr" : "Abril",
      "may" : "Mayo",
      "jun" : "Junio",
      "jul" : "Julio",
      "aug" : "Agosto",
      "sep" : "Septiembre",
      "oct" : "Octubre",
      "nov" : "Noviembre",
      "dec" : "Diciembre"
    },
    "noEvents": "Aún no hay eventos en este canal :("
  }
}
</i18n>

<style scoped>
  .arrow {
    color: #929292 !important;
    border: none !important;
  }

  .arrow:hover {
    color: #929292 !important;
    background-color: transparent !important;
    border: none !important;
  }

  .arrow:focus {
    color: #929292 !important;
    background-color: transparent !important;
    border: none !important;
  }

  .button-add {
    background-color: #111111 !important;
    color: #ffffff !important;
    border: #111111 solid 1px;
  }
</style>
